export const formatDate = (dateString) => {
  // If the value is 'N/A', return it as is
  if (dateString === "N/A") return "N/A";
  // If no dateString or it's an empty object ({}), return a dash
  if (
    !dateString ||
    (typeof dateString === "object" && Object.keys(dateString).length === 0)
  )
    return "-";

  // Try to format as a date, fallback to original string if invalid
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString; // Return original if invalid date

  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit", // Added seconds
    hour12: false, // Explicitly set 12-hour format
  });
};

export const getPageNumbers = (pagination) => {
  const { page, totalPages } = pagination;

  // If total pages are 7 or less, show all pages
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  // Always show first page, last page, and pages around current page
  let pages = [1];

  // Add ellipsis if current page is far from the beginning
  if (page > 3) {
    pages.push("...");
  }

  // Calculate range around current page
  let rangeStart = Math.max(2, page - 1);
  let rangeEnd = Math.min(totalPages - 1, page + 1);

  // Adjust range if at edges
  if (page <= 3) {
    rangeEnd = 4;
  } else if (page >= totalPages - 2) {
    rangeStart = totalPages - 3;
  }

  // Add page numbers in range
  for (let i = rangeStart; i <= rangeEnd; i++) {
    pages.push(i);
  }

  // Add ellipsis if current page is far from the end
  if (page < totalPages - 2) {
    pages.push("...");
  }

  // Add last page if not already included
  if (totalPages > 1) {
    pages.push(totalPages);
  }

  return pages;
};

export const svgFilterIcon = (
  <svg
    stroke="currentColor"
    fill="none"
    stroke-width="2"
    viewBox="0 0 24 24"
    stroke-linecap="round"
    stroke-linejoin="round"
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
  </svg>
);
